import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlatformDetectionService {
  private _isBrowserSupported = false;
  get isBrowserSupported(): boolean {
    return this._isBrowserSupported;
  }

  constructor(private readonly platform: Platform) {
    console.log('is browser supported (BLINK)? ' + this.platform.BLINK);
    this._isBrowserSupported = this.platform.BLINK;
  }
}
